export const PageHeader = ({ title, subtitle, action }) => (
  <div className="mb-8 flex items-end justify-between gap-4">
    <div>
      <h1 className="font-display text-3xl font-black tracking-tight text-white">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export default PageHeader;
